'use strict';

angular.module('metabuyer.services.approvalEngine.positionAssign', ['ngResource'])
  .factory('positionAssignment', ['$resource', 'pathConstants',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.approvalEngine.positionAssign.get,
        {
          limit: '@limit',
          page: '@page',
          sort: '@sort',
          includes: '@includes',
          filter_groups: '@filter_groups',
          position: '@position'
        },
        {
          'get': { method: 'GET' },
          'post': { method: 'POST' },
          'put': { method: 'PUT' }
        }
      );
    }])
  .factory('positionAssignmentSingle', ['$resource', 'pathConstants',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.approvalEngine.positionAssign.single,
        {
          id: '@id'
        },
        {
          'get': { method: 'GET' },
          'put': { method: 'PUT' },
          'delete': { method: 'DELETE' }
        }
      );
    }])